import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import ThemeToggle from '@/components/Helper/ThemeToggle';
import { useTheme } from 'next-themes';
import { useMounted } from '@/hooks/mounted.hook';

export default function AuthLayout() {
  const mounted = useMounted();
  const { resolvedTheme } = useTheme();

  // Loka blue glow in the bottom corners
  const glow = resolvedTheme === 'dark' ? 'rgba(57, 116, 246, 0.55)' : 'rgba(57, 116, 246, 0.25)';
  const backgroundImage = `radial-gradient(ellipse 55% 90% at 0% 100%, ${glow}, transparent 70%), radial-gradient(ellipse 55% 90% at 100% 100%, ${glow}, transparent 70%)`;

  if (!mounted) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-no-repeat bg-[#F6F6F6] dark:bg-[#1C1C1E]">
      {/* Content */}
      <div className="ml-auto p-5">
        <ThemeToggle size={25} />
      </div>
      <main
        className={`flex-1 flex justify-center px-4 lg:pb-16 lg:pt-40 ${resolvedTheme === 'dark' ? 'bg-[#1C1C1E]' : 'bg-[#F6F6F6]'
          }`}
        style={{
          backgroundImage,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center bottom',
          backgroundSize: '100% 50%',
        }}
      >
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
